import script from "./HealthGoalForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./HealthGoalForm.vue?vue&type=script&setup=true&lang=ts"

import "./HealthGoalForm.vue?vue&type=style&index=0&id=6120510b&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6120510b"]])

export default __exports__